import React from 'react'
import { Alert, Button, Typography } from '@mui/material'
import AppDialog from '../../../components/dialog/AppDialog'

export default function PriceDeletionDialog({ deletion, confirmation, deleting, selectionStale, error, onClose, onReload, onConfirm }) {
    return (
        <AppDialog
            open={Boolean(deletion)}
            onClose={onClose}
            title={confirmation.title}
            maxWidth='sm'
            actions={
                <>
                    <Button disabled={deleting} onClick={onClose}>Cancel</Button>
                    {selectionStale ? (
                        <Button disabled={deleting} onClick={onReload}>Reload selection</Button>
                    ) : (
                        <Button color='error' variant='contained' disabled={deleting} onClick={onConfirm}>
                            {deleting ? 'Deleting...' : 'Delete'}
                        </Button>
                    )}
                </>
            }>
            <Typography>{confirmation.message}</Typography>
            <Alert severity='warning'>This removes local cached prices only, not SAP source prices. Future pricing requests may recreate them. Other builders are not affected.</Alert>
            {error && <Alert severity='error'>{error}</Alert>}
        </AppDialog>
    )
}
